import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'admin-brands:density';
const DEFAULT_DENSITY = 'comfortable';

const readInitial = () => {
    if (typeof window === 'undefined') return DEFAULT_DENSITY;
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        return stored === 'comfortable' || stored === 'compact' ? stored : DEFAULT_DENSITY;
    } catch (_) {
        return DEFAULT_DENSITY;
    }
};

const DensityContext = createContext({
    density: DEFAULT_DENSITY,
    setDensity: () => {},
    toggle: () => {}
});

export const DensityProvider = ({ children }) => {
    const [density, setDensityState] = useState(readInitial);

    useEffect(() => {
        try {
            window.localStorage.setItem(STORAGE_KEY, density);
        } catch (_) {
            /* storage may be unavailable (private mode etc.) — harmless */
        }
    }, [density]);

    const value = useMemo(
        () => ({
            density,
            setDensity: setDensityState,
            toggle: () => setDensityState((prev) => (prev === 'compact' ? 'comfortable' : 'compact'))
        }),
        [density]
    );

    return <DensityContext.Provider value={value}>{children}</DensityContext.Provider>;
};

export const useDensity = () => useContext(DensityContext);
